export class Correo {

    public idCompania: string;
    public idCorreo: string;
    public idCodigoGrupo: string;
    public email: string;

    public descripcion: string;
}